import { useMemo } from "react";
import type { TeamConflictDetail } from "./types";
import { TableHeaderType } from "@/components/tables/types";
import { NumberFormatter } from "@/uiCore";

interface UseConflictingTeamsTableHeadersProps {
  currency: string;
  responseCurrency?: string;
}

const useConflictingTeamsTableHeaders = ({
  currency,
  responseCurrency,
}: UseConflictingTeamsTableHeadersProps) => {
  return useMemo<TableHeaderType<TeamConflictDetail>[]>(() => {
    return [
      {
        id: 1,
        label: "Conflicting Team",
        uid: "team_name",
        width: "16%",
        render: (item: TeamConflictDetail) => (
          <span className="al-font-medium al-text-foreground">{item.team_name}</span>
        ),
        sort: {
          sortSearchKey: "sortAttribute",
        },
      },
      {
        id: 2,
        label: "Entity Type",
        uid: "entity_type",
        width: "10%",
        render: (item: TeamConflictDetail) => (
          <span className="al-capitalize al-text-muted-foreground">{item.entity_type}</span>
        ),
        sort: {
          sortSearchKey: "sortAttribute",
        },
      },
      {
        id: 3,
        label: "Entity Name",
        uid: "entity_name",
        width: "16%",
        render: (item: TeamConflictDetail) => (
          <span className="al-text-foreground">{item.entity_name}</span>
        ),
        sort: {
          sortSearchKey: "sortAttribute",
        },
      },
      {
        id: 4,
        label: "Warehouse",
        uid: "warehouse_name",
        width: "12%",
        render: (item: TeamConflictDetail) => (
          <span className="al-text-muted-foreground">{item.warehouse_name ?? "-"}</span>
        ),
        sort: {
          sortSearchKey: "sortAttribute",
        },
      },
      {
        id: 5,
        label: "Database",
        uid: "database",
        width: "12%",
        render: (item: TeamConflictDetail) => (
          <span className="al-text-muted-foreground">{item.database ?? "-"}</span>
        ),
        sort: {
          sortSearchKey: "sortAttribute",
        },
      },
      {
        id: 6,
        label: "Schema",
        uid: "schema",
        width: "10%",
        render: (item: TeamConflictDetail) => (
          <span className="al-text-muted-foreground">{item.schema ?? "-"}</span>
        ),
        sort: {
          sortSearchKey: "sortAttribute",
        },
      },
      {
        id: 7,
        label: "Query Cost",
        uid: "query_cost",
        width: "14%",
        render: (item: TeamConflictDetail) => (
          <span className="al-font-medium al-text-foreground">
            <NumberFormatter
              value={item.query_cost ?? 0}
              options={{ currency: responseCurrency ?? currency }}
            />
          </span>
        ),
        sort: {
          sortSearchKey: "sortAttribute",
        },
      },
    ];
  }, [currency, responseCurrency]);
};

export default useConflictingTeamsTableHeaders;
